import { useState, useEffect } from "react";

const useGetInterests = (productsArr, userData) => {
  const interests = userData.interests;
  const [interestsObj, setinterestsObj] = useState([]);

  const pushInterestsToState = async () => {
    const tempInterests = [];
    await Promise.all(
      interests?.map((interest) => {
        const sameCategInterests = productsArr?.filter(
          (prod) => prod.category === interest
        );
        tempInterests.push({
          interestLabel: interest,
          interestProducts: sameCategInterests,
        });
      })
    ).then(() => setinterestsObj(tempInterests));
  };

  useEffect(() => {
    if (interests) {
      pushInterestsToState();
      console.log("interests pushed");
    }
  }, [interests]);

  return { interestsObj };
};

export default useGetInterests;
